import React from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import Image from 'gatsby-image'
import { LinkType } from '../shared'

import {
  desktopVw,
  desktopBreakpoint,
  mobileVw,
  colors,
  fonts,
} from '../../styles'

import { useLang, useLocale, useSearchAnalytics } from '../../hooks'

export const SearchResults = ({ search }) => {
  const locale = useLocale()
  const lang = useLang()
  const data = useStaticQuery(graphql`
    query {
      allContentfulPageRecipe {
        nodes {
          node_locale
          thumbnailImage {
            fluid {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
            title
          }
          title
          slug
          relatedProducts {
            title
          }
        }
      }
      #Fetch all articles so that search bar could search for articles as well
      allContentfulPageArticle {
        nodes {
          node_locale
          thumbnailImage {
            fluid {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
            title
          }
          title
          slug
          relatedProducts {
            title
          }
        }
      }
    }
  `)
  const localeRecipe = []
  const localeArticle = []
  data.allContentfulPageRecipe.nodes.map((obj) => {
    if (obj.node_locale === locale && obj.title && obj.thumbnailImage && obj.slug) localeRecipe.push(obj)
  })

  data.allContentfulPageArticle.nodes.map((obj) => {
    if (obj.node_locale === locale && obj.title && obj.thumbnailImage && obj.slug)
      localeArticle.push(obj)
  })

  const allData = [...localeRecipe, ...localeArticle]
  const matchingRecipes = []

  const normalize = (search) => {
    const newSearch = search
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace("'", '')
    return newSearch
  }

  const getRecipes = () => {
    allData.map(
      ({ relatedProducts }, i) =>

        relatedProducts && relatedProducts.map(({ title }) =>
          normalize(title).includes(normalize(search)) ||
            normalize(allData[i].title).includes(normalize(search))
            ? matchingRecipes.push(allData[i])
            : null,
        ),
    )
  }

  const getRecipesCanada = () => {
    allData.map(
      ({ title }, i) =>
        (normalize(title).includes(normalize(search)) || normalize(allData[i].title).includes(normalize(search)))
        && matchingRecipes.push(allData[i])
    )
  }

  return (
    <Wrapper onClick={() => useSearchAnalytics(search, matchingRecipes.length)}>
      {locale === 'fr' ? getRecipes() : getRecipesCanada()}
      {search && matchingRecipes.length == 0 ? (
        <Span>Désolé votre recherche n'a renvoyé aucun résultat.</Span>
      ) : null}

      <Recipes>
        {search && matchingRecipes
          ? Array.from(new Set(matchingRecipes)).map(
            ({ title, thumbnailImage, slug }, i) => (
              <RecipeWrapper key={i} to={`/${lang}${slug}`} alt={title}>
                <StyledImage
                  fluid={thumbnailImage && thumbnailImage.fluid}
                  alt={thumbnailImage && thumbnailImage.title}
                />
                <RecipeTitle>{title}</RecipeTitle>
              </RecipeWrapper>
            ),
          )
          : null}
      </Recipes>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin: 0;

  @media (min-width: ${desktopBreakpoint}) {
    margin: 0;
  }
`

const RecipeWrapper = styled(LinkType)`
  margin: ${mobileVw(10)} 0 ${mobileVw(30)};
  display: block;

  @media (min-width: ${desktopBreakpoint}) {
    margin: 0;
  }
`

const Recipes = styled.div`
  display: block;

  @media (min-width: ${desktopBreakpoint}) {
    display: flex;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: ${desktopVw(80)} ${desktopVw(30)};
  }
`

const Span = styled.h2`
  padding: ${mobileVw(16)} 0 0;

  @media (min-width: ${desktopBreakpoint}) {
    font-size: ${desktopVw(26)};
    padding: 0;
  }
`

const RecipeTitle = styled.h2`
  font-size: ${mobileVw(18)};
  line-height: ${mobileVw(18)};
  font-family: ${fonts.splandor};
  margin: ${mobileVw(18)} 0 ${mobileVw(8)} 0;

  @media (min-width: ${desktopBreakpoint}) {
    font-size: ${desktopVw(24)};
    line-height: ${desktopVw(24)};
    margin: ${desktopVw(22)} 0 ${desktopVw(10)} 0;
  }
`

const StyledImage = styled(Image)`
  height: ${mobileVw(264)};

  @media (min-width: ${desktopBreakpoint}) {
    height: ${desktopVw(280)};
  }
`
